import { useEffect, useState } from "react";
import { AlertTriangle, Users } from "lucide-react";
import { api } from "@/lib/api";
import { functieRowNeedsAttention, functieRowTexts } from "@/lib/functieCoverage";

// Round U — Beheer → Dekking → "Per functie": open targeted questions and memos per functie. Hidden on error.
export function FunctieCoverage({ refreshKey }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/coverage/functies").then(({ data }) => setRows(Array.isArray(data) ? data : null)).catch(() => setRows(null));
  }, [refreshKey]);
  if (!rows || !rows.length) return null;
  return (
    <div className="mt-10" data-testid="admin-coverage-functies">
      <div className="flex items-center gap-2 mb-3">
        <Users size={14} className="text-tw-yellow" strokeWidth={2.5} />
        <h3 className="font-mono text-[10px] tracking-[0.3em] text-tw-muted uppercase">Per functie</h3>
      </div>
      <p className="text-xs text-tw-muted mb-4 max-w-xl leading-relaxed">
        Open vragen per functie en hoeveel die collega's de laatste 30 dagen hebben ingesproken. Geel: hier zijn nieuwe vragen of een duwtje nodig.
      </p>
      <ul className="grid gap-[3px]">
        {rows.map((r) => <FunctieRow key={r.functie} row={r} />)}
      </ul>
    </div>
  );
}

const FunctieRow = ({ row }) => {
  const warn = functieRowNeedsAttention(row);
  const t = functieRowTexts(row);
  const id = row.functie.replace(/\s+/g, "-").toLowerCase();
  return (
    <li data-testid={`admin-coverage-functie-${id}`} data-warn={warn ? "true" : "false"}
      className={`bg-tw-surface border border-tw border-l-4 ${warn ? "border-l-tw-yellow" : ""} px-4 py-3 min-w-0`}>
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <strong className="text-white break-words">{row.functie}</strong>
        <span className={`font-mono text-[10px] uppercase tracking-[0.12em] ${row.targeted_open ? "text-white" : "text-tw-yellow"}`}
          data-testid={`admin-coverage-functie-${id}-open`}>{t.open}</span>
        <span className={`font-mono text-[10px] uppercase tracking-[0.12em] ${row.memos_30d ? "text-tw-muted" : "text-tw-yellow"}`}
          data-testid={`admin-coverage-functie-${id}-memos`}>{t.memos}</span>
        {warn && <AlertTriangle size={12} className="text-tw-yellow self-center" strokeWidth={2.5} aria-label="Aandacht nodig" />}
      </div>
      <p className="mt-1 text-xs text-tw-muted break-words" data-testid={`admin-coverage-functie-${id}-users`}>{t.users}</p>
    </li>
  );
};
